import { PostAnswerActionsConfig } from "@/api/simulator/simulator.model";
import { Release } from "@/v2/entities/release/Release.model";

export enum SimulatorChannel {
  helpcenter = "helpcenter",
  autonomous_ticket_event = "autonomous_ticket_event",
  autonomous_quackchat = "autonomous_quackchat",
  slackbot = "slackbot",
  copilot = "copilot",
  knowledge_hub = "knowledge_hub",
}

export interface Simulator {
  id: number;
  tenantId: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  publishedReleaseId?: number;
  draftReleaseId?: number;
  seperateGoodFeedback: boolean;
  channel: SimulatorChannel;
  shouldCloseTicket: boolean;
  timeDifferenceLimit: number;
  allowRegularAttachments: boolean;
  allowInlineAttachments: boolean;
  reclassifyTopicOnSubsequentAnswers?: boolean;
  postAnswerActions?: PostAnswerActionsConfig;
  releases?: Release[];
}

export interface UpsertSimulatorParamsDto {
  name: string;
  publishedReleaseId?: number;
  channel?: SimulatorChannel;
  seperateGoodFeedback?: boolean;
  timeDifferenceLimit?: number;
  allowInlineAttachments?: boolean;
  allowRegularAttachments?: boolean;
  reclassifyTopicOnSubsequentAnswers?: boolean;
  postAnswerActions?: PostAnswerActionsConfig;
}

export interface UpsertReleaseParamsDto {
  releasePolicy: string;
  filterPolicy?: string;
  customToneOfVoice?: string;
}

export interface GetSimulatorReleasesQueryDto {
  includeConversations?: boolean;
  includeMessages?: boolean;
}

export interface GetSimulatorByIdQueryDto {
  includeInteractionEvents?: boolean;
}

export type GetSimulatorReleasesWithConversationsResponse = Release[];

type StatusOption = {
  value: string;
  label: string;
};

type CustomFieldOption = {
  id: string;
  label: string;
  type: 'text' | 'select' | 'multiselect' | 'checkbox' | 'number' | 'date';
  options?: { value: string; label: string }[];
};

export type GetPostAnswerActionsOptions = {
  statuses: StatusOption[];
  customFields: CustomFieldOption[];
}
